export enum MppCountries {
  FR = 'France',
  US = 'US',
}
